<template>
  <card>
    <list
      v-if="$store.state.user.sections['loans']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: " col-12 col-md-6",
          key: "loan_amount_desired",
          label: "Сумма кредита",
          type: "field",
          textType: "number",
        },
        {
          col: " col-12 col-md-6",
          key: "loan_term_desired",
          label: "Срок кредита",
          type: "field",
          textType: "number",
        },
        {
          col: " col-12 col-md-12",
          key: "loan_goal",
          label: "Цель кредита",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_loan",
      itemLink: "loans",
      setLink: "loans",
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "dealer",
          object: "name",
          title: "Компания",
        },
        {
          key: "bank",
          object: "name",
          title: "Банк",
          disableLink: true,
        },
        {
          key: "loan_amount_desired",
          title: "Сумма кредита",
        },
        {
          key: "loan_term_desired",
          title: "Срок кредита",
        },
        {
          key: "loan_goal",
          title: "Цель кредита",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
          title: "Дата создания",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
